import { render, staticRenderFns } from "./ConsultantworkloadAllocationMonth.vue?vue&type=template&id=68fcb388&scoped=true&"
import script from "./ConsultantworkloadAllocationMonth.vue?vue&type=script&lang=js&"
export * from "./ConsultantworkloadAllocationMonth.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantworkloadAllocationMonth.vue?vue&type=style&index=0&id=68fcb388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fcb388",
  null
  
)

export default component.exports